import { render } from "./TestConnection.vue?vue&type=template&id=24029b6a"
import script from "./TestConnection.vue?vue&type=script&lang=js"
export * from "./TestConnection.vue?vue&type=script&lang=js"

import "./TestConnection.vue?vue&type=style&index=0&id=24029b6a&lang=css"

import exportComponent from "/home/franck_boullier/Documents/bitbucket/exchange-app-admin-vue-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__